import { Banner, Box, CloseButton } from '@zillow/constellation-10';

import PropertiesPageConstants from '../../../srcLegacy/shared/containers/PropertiesPage/PropertiesPageConstants';

import { bannerBoxRecipe } from './styles';

import { useAuth } from '../AuthProvider';

type Props = {
  displayPaymentsNotification: boolean;
  displayApplicationsNotification: boolean;
  displayLeasesNotification: boolean;
  displayListingClaimCompleteBanner: boolean;
  handleBannerCloseClick: (arg: (typeof PropertiesPageConstants)[keyof typeof PropertiesPageConstants]) => void;
};

const Notifications = ({
  displayPaymentsNotification,
  displayApplicationsNotification,
  displayLeasesNotification,
  displayListingClaimCompleteBanner,
  handleBannerCloseClick,
}: Props): JSX.Element => {
  const { user } = useAuth();

  return (
    <div>
      {displayListingClaimCompleteBanner && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick(PropertiesPageConstants.DISPLAY_LISTING_CLAIM_COMPLETE_BANNER)}
          >
            Select a property below to view and manage its information
          </Banner>
        </Box>
      )}

      {displayApplicationsNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick(PropertiesPageConstants.DISPLAY_APPLICATIONS_NOTIFICATION)}
          >
            Applications are enabled for your properties. You can change application preferences anytime on the
            property&apos;s&nbsp;
            <em>Applications</em>
            &nbsp;tab.
          </Banner>
        </Box>
      )}

      {displayPaymentsNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick(PropertiesPageConstants.DISPLAY_PAYMENTS_NOTIFICATION)}
          >
            To manage your rent payments, select&nbsp;
            <em>Payments</em>
            &nbsp;for any property below
          </Banner>
        </Box>
      )}

      {displayLeasesNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick(PropertiesPageConstants.DISPLAY_LEASES_NOTIFICATION)}
          >
            For your properties with a&nbsp;
            <em>Leases</em>
            {}
             tab, select on it to create a custom lease
          </Banner>
        </Box>
      )}
    </div>
  );
};

export default Notifications;
